import { createStyles, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function () {
    return createStyles({
        textArea: {
            outlineColor: 'var(--primario-morado)',
            borderColor: 'var(--text-area-label)',
            padding: '0.625rem',
            fontSize: '0.875rem',
            '&::placeholder': {
                color: 'var(--text-area-label)',
            },
        },
        textAreaError: {
            borderColor: 'var(--error)',
            outlineColor: 'var(--error)',
            '&::placeholder': {
                color: 'var(--error)',
            },
        },
    });
});
export default useStyles;
